// extracted by mini-css-extract-plugin
export var copyableField = "_qy-4";
export var customerBadge = "_qy-0";
export var customerInfoTitle = "_qy-2";
export var details = "_qy-1";
export var dropdownContainer = "_qy-5";
export var dropdownImage = "_qy-6";
export var editAssigneeForm = "_qy-a";
export var editButton = "_qy-3";
export var email = "_qy-7";
export var hidden = "_qy-d";
export var input = "_qy-8";
export var saveButton = "_qy-b";
export var shopifyIcon = "_qy-c";
export var suggestionBadge = "_qy-e";
export var suggestionText = "_qy-f";
export var username = "_qy-9";